import api from './api';

const tenantCustomerService = {
  async listCustomers(search = '') {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const res = await api.get(`/customers${params}`);
    return res.data.customers;
  },

  async getCustomerDetail(customerId) {
    const res = await api.get(`/customers/${customerId}`);
    return res.data.customer;
  },

  async updateCustomer(customerId, data) {
    const res = await api.patch(`/customers/${customerId}`, data);
    return res.data.customer;
  },

  async mergeCustomers(keepId, removeId) {
    const res = await api.post(`/customers/${keepId}/merge`, { removeId });
    return res.data.customer;
  },

  async getDuplicates() {
    const res = await api.get('/customers/duplicates');
    return res.data.suggestions;
  },

  async createCustomer(name, phone) {
    const res = await api.post('/customers', { name, phone });
    return res.data.customer;
  },

  /**
   * Solicita o telefone de um contato sem número (fluxo REQUEST_CONTACT_INFO,
   * ADR-0016 / Fase 5). Dispara o template WhatsApp com o botão de compartilhar
   * contato. Retorna o payload do backend:
   *   - { status: "sent" }
   *   - { status: "unavailable", reason: "bsuid_send_disabled" }
   * Erros (ex.: 409 contact_has_phone) propagam para o chamador tratar.
   * @param {string} customerId
   * @returns {Promise<object>}
   */
  async requestContactInfo(customerId) {
    const res = await api.post(`/customers/${customerId}/request-contact-info`);
    return res.data;
  },
};

export default tenantCustomerService;
